/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import {
  AbstractRestService,
  arrayOf,
  identity,
  none,
  RestSettings,
  SlicedDataSource,
} from '@gh/core-data';
import { Observable } from 'rxjs';
import { CommunicationAttachmentDto } from '../communications';
import { JcsDetailsDto } from './job-color-selection.dto';
import { JcsDetailsMapper } from './job-color-selection.mapper';
import { JobListFilterDto, JobListItemDto } from './job.dto';
import { JobListFilterMapper, JobListItemMapper } from './job.mapper';

@Injectable()
export class JobColorSelectionRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(jobId: ID, csMasterId?: ID): Observable<JcsDetailsDto> {
    return this.httpGet(`${this.bp}/jobs/${jobId}/color-selection`, { csMasterId }, identity(), JcsDetailsMapper);
  }

  update(jobId: ID, colorSelection: JcsDetailsDto): Observable<JcsDetailsDto> {
    return this.httpPut(`${this.bp}/jobs/${jobId}/color-selection`, colorSelection, JcsDetailsMapper);
  }

  produce(jobId: ID): Observable<CommunicationAttachmentDto> {
    return this.httpPut(`${this.bp}/jobs/${jobId}/color-selection/produce`, void 0, none(), identity());
  }

  findAllAsDataSource(filter: JobListFilterDto): SlicedDataSource<JobListItemDto> {
    return this.createSlicedDataSourceGet(`${this.jad}/job-colour-selections`,
                                          filter, JobListFilterMapper, arrayOf(JobListItemMapper));
  }
}
